export default "__VITE_ASSET__$8qTmfX8__"